import { render, staticRenderFns } from "./CarrinhoOfertaTotal.vue?vue&type=template&id=9bfb82f6"
import script from "./CarrinhoOfertaTotal.vue?vue&type=script&lang=js"
export * from "./CarrinhoOfertaTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports